import { AnimatePresence } from 'motion/react';
import { PropsWithChildren } from 'react';
import { Routes, useLocation, useNavigationType } from 'react-router-dom';

import { ShellNavigationTypeContext } from '@/data/context/ShellNavigationTypeContext';
import useShellFrameKind from '@/data/hook/app-shell/useShellFrameKind';

type ShellFrameRoutesProps = PropsWithChildren<{
  focusPaths: string[];
}>;

export default function ShellFrameRoutes({
  focusPaths,
  children,
}: ShellFrameRoutesProps) {
  const location = useLocation();
  const navigationType = useNavigationType();
  const frameKind = useShellFrameKind(focusPaths);

  return (
    <ShellNavigationTypeContext.Provider value={navigationType}>
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={frameKind}>
          {children}
        </Routes>
      </AnimatePresence>
    </ShellNavigationTypeContext.Provider>
  );
}
